import { NgClass } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import type { spriConfirmationConfig } from '@spri/services/confirmation/confirmation.types';

@Component({
  selector: 'spri-confirmation-dialog',
  templateUrl: './dialog.component.html',
  styles: [
    `
      .spri-confirmation-dialog-panel {
        @screen md {
          @apply w-128;
        }

        .mat-mdc-dialog-container {
          .mat-mdc-dialog-surface {
            padding: 0 !important;
          }
        }

        .spri-confirmation-confirm-btn {
          background-color: var(--tenant-primary-color, #77c4d5) !important;
          color: #fff !important;
          border-radius: 0 !important;
        }

        .spri-confirmation-cancel-btn {
          color: var(--tenant-primary-color, #77c4d5) !important;
          background-color: transparent !important;
        }

        .spri-confirmation-cancel-btn:hover {
          color: #000 !important;
          background-color: transparent !important;
        }

        /* Wrapper reserves space so pointer triangle can extend below dialog surface */
        .spri-confirmation-dialog-pointer-wrap {
          flex-shrink: 0;
          position: relative;
          height: 14px;
          overflow: visible;
          pointer-events: none;
        }

        /* Triangle extends below wrapper (and dialog) to point at delete button */
        .spri-confirmation-dialog-pointer {
          position: absolute;
          right: 32px;
          bottom: 0;
          width: 0;
          height: 0;
          pointer-events: none;
          border-left: 12px solid transparent;
          border-right: 12px solid transparent;
          border-top: 14px solid #f9fafb;
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));
          z-index: 1;
        }

        .spri-confirmation-has-pointer {
          padding-bottom: 0;
        }

        .spri-confirmation-dialog-panel .mat-mdc-dialog-container .mat-mdc-dialog-surface {
          padding-bottom: 0 !important;
          overflow: visible !important;
        }

        .spri-confirmation-dialog-panel:has(.spri-confirmation-has-pointer)
          .mat-mdc-dialog-container
          .mat-mdc-dialog-surface {
          border-bottom-left-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        .spri-confirmation-dialog-panel,
        .spri-confirmation-dialog-panel .mat-mdc-dialog-container,
        .spri-confirmation-dialog-panel .mat-mdc-dialog-container .mat-mdc-dialog-surface {
          overflow: visible !important;
        }

        .spri-confirmation-dialog-panel .mat-mdc-dialog-container .mat-mdc-dialog-surface {
          position: relative !important;
        }
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, NgClass],
})
export class spriConfirmationDialogComponent {
  data: spriConfirmationConfig = inject(MAT_DIALOG_DATA);
}
